import { IRequestConfig } from '@/features/pcidss/store/pcidss.types';
import { THttpBodyType } from '@/types/FetchService.types';

export const PCIDSS_HOSTS_MAPPING: Record<string, string> = {
  '.sandbox.treezor.co': '.public.preprod.secure.treezor.co',
};

export const PCIDSS_MAPPING: Record<string, (baseURL: string, body?: THttpBodyType) => Partial<IRequestConfig>> = {
  'POST-v1/cards/RequestPhysical': (baseURL, body) => ({
    pathname: 'v1/cards',
    method: 'POST',
    body: JSON.stringify({
      ...(typeof body === 'string' ? JSON.parse(body) : Object.fromEntries(body)),
      medium: 'physical',
    }),
    baseURL,
  }),
  'POST-v1/cards/CreateVirtual': (baseURL, body) => ({
    pathname: 'v1/cards',
    method: 'POST',
    body: JSON.stringify({
      ...(typeof body === 'string' ? JSON.parse(body) : Object.fromEntries(body)),
      medium: 'virtual',
    }),
    baseURL,
  }),
};
